
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompleteSfdrStrategy"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SfdrStrategyType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kind"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"benchmarkDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actionsTaken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metricIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"concept"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ixId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"euTaxonomyConcept"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ixId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"strategyDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isEnvironmentalGoal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCo2EmissionGoal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"doCheckEuTaxonomyAlignment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ventureIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esStrategy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esCharacteristicsDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"esgIntegrationDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exclusionCriteriaDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bestInClassDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"normBasedScreeningDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityLabelDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isIndexDesignated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sustainablyAlignedIndexExplanation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"investmentAlignedIndexExplanation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"broadMarketIndexComparison"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"indexCalculationMethodology"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sustainabilityIndicatorsMonitoringStrategy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"entityResponsibleForMonitoringIndicators"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isConsideringSourcesAndEstimates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataSourcesConsidered"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareOfDataSecondHand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dueDiligenceProcessDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"engagementPolicyWithSpecificInvestmentStrategy"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":948}};
    doc.loc.source = {"body":"fragment CompleteSfdrStrategy on SfdrStrategyType {\n  id\n  kind\n  benchmarkDescription\n  actionsTaken\n  metricIds\n  metrics {\n    id\n    name\n  }\n  concept {\n    id\n    label\n    ixId\n  }\n  euTaxonomyConcept {\n    id\n    label\n    ixId\n  }\n  strategyDescription\n  isEnvironmentalGoal\n  isCo2EmissionGoal\n  doCheckEuTaxonomyAlignment\n  ventureIds\n\n  esStrategy\n  esCharacteristicsDescription\n  esgIntegrationDescription\n  exclusionCriteriaDescription\n  bestInClassDescription\n  normBasedScreeningDescription\n  sustainabilityLabelDescription\n  isIndexDesignated\n  sustainablyAlignedIndexExplanation\n  investmentAlignedIndexExplanation\n  broadMarketIndexComparison\n  indexCalculationMethodology\n\n  sustainabilityIndicatorsMonitoringStrategy\n  entityResponsibleForMonitoringIndicators\n  isConsideringSourcesAndEstimates\n  dataSourcesConsidered\n  shareOfDataSecondHand\n  dueDiligenceProcessDescription\n  engagementPolicyWithSpecificInvestmentStrategy\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CompleteSfdrStrategy"] = oneQuery(doc, "CompleteSfdrStrategy");
        
